export default "__VITE_ASSET__DUfdgRyh__"